import { KYMW0900Model } from '../kymw0900.model';
import { SupplierRequestVO } from '../vo/kymw0900-supplier-request.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 取引先情報取得クラス
 *
 * @export GetSupplierService
 * @class GetSupplierService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetSupplierService extends PlessJsonResponderSub<any> {

  model: KYMW0900Model;

  private vo: SupplierRequestVO = new SupplierRequestVO();

  /**
   * 処理に使用するModel
   *
   * @private
   * @type {KYMW0C00Model}
   * @memberof GetSupplierService
   */

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof GetSupplierService
   */
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetSupplierService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        Supplier: this.vo.supplier
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param {Function} successFunc 成功時後続処理
   * @memberof GetSupplierService
   */
  execute(model: any, vo: SupplierRequestVO, successFunc: Function = null): void {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('getPlanGoodsSupplier', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetSupplierService
   */
  success(data: any): void {
    if (this.vo.flag === '0') {
      this.model.setOrderClientName(data);
    } else {
      this.model.setPayeeClientName(data);
    }
  }

  /**
   * API通信失敗時の処理
   *
   * @param {*} errList レスポンスデータ
   * @memberof GetSupplierService
   */
  public plessErrorHandler(errList: Object): void {
    // 値をクリア
    if (this.vo.flag === '0') {
      this.model.orderClientName = '';
    } else {
      this.model.payeeClientName = '';
    }
    super.plessErrorHandler(errList);
  }
}
